<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <div class="row" style="margin-top: 20px;margin-bottom: 20px;">
                                <div class="col">
                                    <h4 class="mb-4">Bank Client Details</h4>
                                </div>
                                <div class="col">
                                    <h4>
                                        <button id="reconBtn" class="btn btn-primary" v-on:click="navigateUploadDashboard()">
                                            Reconciliation
                                        </button>
                                    </h4>
                                </div>
                            </div>
                            <div class="panelDiv">
                                <!-- Button to Open the Modal -->
                                <button id="btnNewMap"
                                        type="button"
                                        class="btn btn-primary float-right"
                                        data-toggle="modal"
                                        data-target="#myModal"
                                        @click="modalview">
                                    Add New Mapping
                                </button>
                                <div class="container">
                                    <div style="padding-bottom: 20px;">
                                        <div class="float-left" style="margin-left:30px;">
                                            <h4></h4>
                                        </div>

                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="container">
                                        <!-- The Modal -->
                                        <div class="modal" id="myModal">
                                            <div class="modal-dialog">
                                                <div class="modal-content" style="margin-top:50%;">
                                                    <!-- Modal Header -->
                                                    <div class="modal-header">
                                                        <h4 class="modal-title">Add, Map Details</h4>
                                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                                    </div>
                                                    <!-- Modal body -->
                                                    <div class="modal-body">
                                                        <div class="container" v-if="adddialog">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <label>Bank Name</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.bankname"
                                                                           list="bankdetails"
                                                                           v-validate="'required|bankClientValidator'"
                                                                           name="bname"
                                                                           v-on:change="handleUpdatedBank()" />
                                                                    <datalist id="bankdetails">
                                                                        <option v-for="(bankitem,index) in bankListDetails"
                                                                                v-bind:key="'bankitem'+index">
                                                                            {{bankitem}}
                                                                        </option>
                                                                    </datalist>
                                                                </div>
                                                                <div class="col">
                                                                    <label>Client Name</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.clientname"
                                                                           list="clientdetails"
                                                                           v-validate="'required|bankClientValidator'"
                                                                           name="cname"
                                                                           v-on:change="handleUpdatedClient()" />
                                                                    <datalist id="clientdetails">
                                                                        <option v-for="(clientitem,index) in clientListDetails"
                                                                                v-bind:key="'clientitem'+index">
                                                                            {{clientitem}}
                                                                        </option>
                                                                    </datalist>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <span v-show="errors.has('bname') ||errors.has('cname')"
                                                                      class="text-danger">Please select valid Bank and Client name</span>
                                                            </div>
                                                        </div>
                                                        <div class="container" v-if="addmessagedialog">
                                                            <div class="alert alert-info">
                                                                <strong>{{addmessage}}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Modal footer -->
                                                    <div class="modal-footer">
                                                        <button type="button"
                                                                class="btn btn-info"
                                                                @click="addMapping"
                                                                v-if="adddialog">
                                                            Add Mapping
                                                        </button>
                                                        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="container">
                                        <div class="row col-sm-12">
                                            <div class="col">
                                                <table id="user-table"
                                                       class="table table-striped display table-bordered nowrap"
                                                       cellspacing="0"
                                                       width="100%">
                                                    <thead>
                                                        <tr>
                                                            <th>Bank Name</th>
                                                            <th>Client Name</th>
                                                            <th data-orderable="false">Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody></tbody>
                                                </table>
                                            </div>
                                            <div class="container">
                                                <div class="modal" id="deleteModal">
                                                    <div class="modal-dialog">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                                <h5 class="modal-title">Delete Mapping</h5>
                                                                <button type="button" id="btnDeleteId" class="close" data-dismiss="modal" aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                Are you sure?
                                                            </div>
                                                            <div class="modal-footer">
                                                                <button type="button" class="btn" id="deleteMap" v-on:click="deleteMapping">Delete</button>
                                                                <button type="button" data-dismiss="modal" class="btn btn-primary">Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--<a v-on:click="navigateBusinessRule()" class="business">Business Rule</a>-->
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import ACRService from '../../services/ACRService/ACR.service.js';
    import CommonService from '../../services/SharedService/common.service.js'
    import { EnvironmentConfig } from '../../services/constants';
    import Algorithm from '../../services/Algorithm.js'

    import $ from 'jquery';
    export default {
        name: "ACRAdmin",
        mixins: [ACRService, CommonService, Algorithm],
        data: () => ({
            dialog: false,
            adddialog: true,
            addmessagedialog: false,
            addmessage: "",
            dataTable: null,
            bankClientListDetails: [],
            bankclientdetails: [],
            bankdetails: [],
            clientdetails: [],
            bankListDetails: [],
            clientListDetails: [],
            editedIndex: -1,
            editedItem: {
                bankname: "",
                clientname: "",
                bankId: "",
                clientId: ""
            },
            editItem: {
                bankname: "",
                clientname: "",
                bankId: "",
                clientId: ""
            }
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Item" : "Edit Item";
            }
        },
        watch: {
            dialog(val) {
                val || this.close();
            }
        },
        created() {
            localStorage.setItem("route", this.$route.name);
        },
        methods: {
            modalview() {
                this.adddialog = true;
                this.addmessagedialog = false;
                this.addmessage = "";
                this.editedItem.bankname = "";
                this.editedItem.clientname = "";
            },
            navigateBusinessRule() {
                this.$router.push("/ACRAdminbuisnessRule");
            },
            navigateUploadDashboard() {
                this.$router.push("/ACRHome");
            },
            deleteMapping() {
                this.RemoveMapping()
                    .then(response => {
                        if (response.data == "success") {
                            this.addUser();
                            $('#deleteModal').modal('toggle');
                        }
                    });
            },
            addUser() {
                this.dataTable.clear().draw();
                this.BankClientMapping().then(Response => {
                    if (Response) {
                        this.bankclientdetails = Response.data;
                        this.bankdetails = this.bankclientdetails;
                        this.clientdetails = this.bankclientdetails;
                        this.bankclientdetails.forEach(bankdetailitem => {
                            this.dataTable.row
                                .add([bankdetailitem.bankname, bankdetailitem.clientname, '<button href="#" class="deleteBtn" > Delete </button>'])
                                .draw(false);
                        });
                        return Response;
                    }
                });
            },
            getKeyByValue(prop, value) {
                let emptyObject = {
                    bankname: "",
                    clientname: "",
                    bankId: -1,
                    clientId: -1
                };
                let temp = this.bankclientdetails.find(item => item[prop] === value);
                if (typeof temp !== "undefined") {
                    return temp;
                } else {
                    return emptyObject;
                }
            },
            handleUpdatedBank() {
                var temp = this.getKeyByValue("bankname", this.editedItem.bankname);
                this.editItem.bankname = this.editedItem.bankname;
                this.editItem.bankId = temp.bankId;
            },
            handleUpdatedClient() {
                var temp = this.getKeyByValue("clientname", this.editedItem.clientname);
                this.editItem.clientname = this.editedItem.clientname;
                this.editItem.clientId = temp.clientId;
            },
            addMapping() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        if (this.editedIndex > -1) {
                            Object.assign(
                                this.bankclientdetails[this.editedIndex],
                                this.editedItem
                            );
                        } else {
                            // For Adding Only Bank
                            if (this.editedItem.bankId === -1 && this.editedItem.clientId > -1) {
                                this.editItem.bankId = 0;
                                this.editItem.clientId = this.editedItem.clientId;
                                this.editItem.bankname = this.editedItem.bankname;
                                this.editItem.clientname = this.editedItem.clientname;
                            }
                            // For Adding Only Client
                            if (this.editedItem.bankId > -1 && this.editedItem.clientId === -1) {
                                this.editItem.bankId = this.editedItem.bankId;
                                this.editItem.clientId = 0;
                                this.editItem.bankname = this.editedItem.bankname;
                                this.editItem.clientname = this.editedItem.clientname;
                            }
                            // For Adding Both Bank and Client
                            if (this.editedItem.bankId === -1 && this.editedItem.clientId === -1) {
                                this.editItem.bankId = 0;
                                this.editItem.clientId = 0;
                                this.editItem.bankname = this.editedItem.bankname;
                                this.editItem.clientname = this.editedItem.clientname;
                            }
                            this.AddBankClientDetails(
                                localStorage.getItem("userName"),
                                this.editItem.bankname,
                                this.editItem.clientname,
                                this.editItem.bankId,
                                this.editItem.clientId
                            ).then(Response => {
                                if (Response) {

                                    this.clientListDetails.push(this.editedItem.clientname);
                                    this.bankListDetails.push(this.editedItem.bankname);
                                    this.addUser();
                                    var resp = Response.data;
                                    this.adddialog = false;
                                    this.addmessagedialog = true;
                                    this.addmessage = resp;
                                    //if (resp == "bank and stickclient mapping already present") {
                                    //    this.adddialog = false;
                                    //    this.addmessagedialog = true;
                                    //    this.addmessage = "Bank and Client mapping already present";

                                    //} else {
                                    //    this.addUser();
                                    //    this.adddialog = false;
                                    //    this.addmessagedialog = true;
                                    //    this.addmessage = "Bank and Client mapping added successfully";
                                    //}
                                } else {
                                    this.adddialog = false;
                                    this.addmessagedialog = true;
                                    this.addmessage = "Error occured during Bank and Client mapping ";
                                }
                            })
                                .catch(function () {
                                    this.adddialog = false;
                                    this.addmessagedialog = true;
                                    this.addmessage = "Error occured during Bank and Client mapping ";
                                });
                        }
                    }
                });

            },
            loadBankClient() {
                var table = this.dataTable;
                this.BankClientMapping().then(Response => {
                    if (Response) {
                        this.bankclientdetails = Response.data;
                        this.bankdetails = this.bankclientdetails;
                        this.clientdetails = this.bankclientdetails;
                        this.bankclientdetails.forEach(bankdetailitem => {
                            table.row
                                .add([bankdetailitem.bankname, bankdetailitem.clientname, '<button href="#" class="deleteBtn" > Delete </button>'])
                                .draw(false);
                        });

                        $('#user-table tbody').on('click', '.deleteBtn', function () {
                            $('#deleteModal').modal({
                                backdrop: 'static',
                                keyboard: false,
                            });
                            var bName = table.row($(this).parents('tr')).data()[0];
                            var cName = table.row($(this).parents('tr')).data()[1];
                            localStorage.setItem("bankName", bName);
                            localStorage.setItem("clientName", cName);
                        });

                        table
                            .row($(this).parents('tr'))
                            .remove().draw(false);
                        return Response;
                    }
                });
            },
            LoadMasterDetails() {
                var authorizeToken = this.authenticateUser(null, EnvironmentConfig._APIURL);
                this.GetMasterDetails(authorizeToken).then(response => {
                    if (response) {
                        for (const item in response.data) {
                            var entity = response.data[item].entityName;
                            var name = response.data[item].name;
                            if (entity == 'acr.banks') {
                                this.bankListDetails.push(name);
                            }
                            if (entity == 'acr.clients') {
                                this.clientListDetails.push(name);
                            }
                        }
                        // this.bankdetails = this.bankclientdetails;
                        // this.clientdetails = this.bankclientdetails;
                    }
                });
            }
        },
        mounted() {
            this.dataTable = $("#user-table").DataTable({
                "pageLength": 50,
                "order": []
            });

            this.loadBankClient();
            this.LoadMasterDetails();
        }
    };
</script>
<style>
    .group {
        display: flex;
        flex: 1;
        justify-content: space-around;
    }

    #reconBtn {
        margin-right: 5px;
        width: 170px;
        float: right;
    }

    #btnNewMap {
        margin-right: -10px;
        width: 170px;
    }

    .business {
        color: transparent !important;
        height: 20px;
        cursor: pointer;
    }

        .business:hover {
            color: transparent
        }
</style>
